import { useState, useEffect } from "react";

const formatNumberWithCommas = (value) => {
  if (!value) return "";
  const parts = value.split(".");
  const integerPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  const decimalPart = parts[1] || "";
  return decimalPart ? `${integerPart}.${decimalPart}` : integerPart;
};

const parseNumber = (value) => {
  return value.replace(/,/g, "");
};

const NumberInputField = ({
  type,
  name,
  register,
  placeholder,
  defaultValue,
  errors,
  label,
  autoComplete,
  currencySymbol = "", // Default is an empty string
  allowNegative = false, // Default is false
}) => {
  const [internalValue, setInternalValue] = useState(
    defaultValue ? formatNumberWithCommas(defaultValue.toString()) : ""
  );

  useEffect(() => {
    setInternalValue(
      defaultValue ? formatNumberWithCommas(defaultValue.toString()) : ""
    );
  }, [defaultValue]);

  const handleChange = (e) => {
    let rawValue = parseNumber(e.target.value).replace(/[^0-9.]/g, "");
    if (allowNegative && rawValue[0] === "-") {
      rawValue = "-" + rawValue.slice(1).replace(/-/g, ""); // Ensure only one negative sign is allowed
    } else {
      rawValue = rawValue.replace(/-/g, ""); // Remove any negative signs if not allowed
    }
    setInternalValue(formatNumberWithCommas(rawValue));
    register(name).onChange({ target: { name, value: rawValue } });
  };

  const handleBlur = (e) => {
    let rawValue = parseNumber(e.target.value).replace(/[^0-9.]/g, "");
    if (allowNegative && rawValue[0] === "-") {
      rawValue = "-" + rawValue.slice(1).replace(/-/g, ""); // Ensure only one negative sign is allowed
    } else {
      rawValue = rawValue.replace(/-/g, ""); // Remove any negative signs if not allowed
    }
    const formattedValue = rawValue.includes(".") ? rawValue : `${rawValue}.00`;
    setInternalValue(formatNumberWithCommas(formattedValue));
    register(name).onBlur({ target: { name, value: formattedValue } });
  };

  return (
    <>
      <div className="input-container relative">
        <label
          htmlFor={name}
          className="block mb-0.5 text-text-1/90 font-medium"
        >
          {label}
        </label>
        <div className="relative">
          {currencySymbol && (
            <span className="absolute left-0 top-1/2 transform -translate-y-1/2 px-3 text-base text-text-1">
              {currencySymbol}
            </span>
          )}
          <input
            className={`w-full px-3 py-0.5 border-b-2 text-base rounded-none border-b-bkg2 bg-content focus:outline-none focus:border-b-primary text-text-1/75 ${
              currencySymbol ? "pl-8" : ""
            }`}
            type="text"
            placeholder={placeholder}
            autoComplete={autoComplete}
            value={internalValue}
            onChange={handleChange}
            onBlur={handleBlur}
            step={type === "number" ? 0.01 : ""}
          />
        </div>
        {
          <p className="text-red-400 text-xs text-wrap w-fit">
            {errors && errors.message} <span className="invisible">Sample</span>
          </p>
        }
      </div>
    </>
  );
};

export default NumberInputField;
